// extracted by mini-css-extract-plugin
export const headBgColorExternal = "#ffffff";
export const headBgColorInternal = "#1c2234";
export const headBgColorShrunkSidebar = "#3c425a";
export const regular = "400";
export const medium = "500";
export const semibold = "600";
export const bold = "700";
export const sans = "'sans'";
export const serif = "'serif'";
export const atlasGrotesk = "'AtlasGrotesk'";
export const amountStep = "AmountStep__amountStep__7q7qA";
export const buttonWrapper = "AmountStep__buttonWrapper__hA0y5";
export const rewardBalance = "AmountStep__rewardBalance__uQOUt";
export const redemptionAmountWrapper = "AmountStep__redemptionAmountWrapper__7hDO+";